import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AppState } from '../../types/store';
import { getActiveSection } from '../../selectors/studio';
import { Props } from './StudioHeader';

export type StateProps = Pick<Props, 'activeSection'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  activeSection: getActiveSection(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
